<template>
<div class="card-row card-row-show">
  <div class="card-header-col card-col w30">
    <Checkbox v-if="disabled" disabled :value="invoice.id" v-model="checked"/>
    <Checkbox v-else @change="addInvoiceNo(invoice)" :value="invoice.id" v-model="checked"/>
  </div>
  <div class="card-row-col card-col w150">
    <router-link :to="{ name: 'InvoiceDetails', params: { invoiceId: invoice.id }}">
      {{invoice.invoice_number}}
    </router-link>
  </div>
  <div class="card-row-col card-col w150">
    {{invoice.created_at | moment("DD MMM YYYY")}}
  </div>
  <!-- <div class="card-row-col card-col w150">
    {{invoice.indents_count}}
  </div> -->
  <div class="card-row-col card-col w200">
    <Ellipsis :text="invoice.transporter.name" :length="25"/>
  </div>
  <div class="card-row-col card-col w150">
    <!-- {{invoice.transporter.ref_id}} -->
    <Ellipsis :text="invoice.transporter.ref_id" :length="10" />
  </div>
  <div class="card-row-col card-col w120">
    <Popover placement="bottom-end" v-model="showLrDetails">
      <div class="payment-popover popover-primary">
        <div class="popover-primary-header">
          <h3>LR Details</h3>
          <span class="remove-icon" @click="showLrDetails=false">
            <svgicon name="cancel" width="10" height="10" :original="true" />
          </span>
        </div>
        <div class="popover-primary-body table-popover">
          <div class="popover-table">
            <div class="popover-table-header">
              <div class="card-col w250">
                Consignee Name
              </div>
              <div class="card-col w150">
                Lr Number
              </div>
            </div>
            <div class="popover-table-row"
               v-for="(lr, index) in getLrDetails.lr_nos"
               :key="index">
              <div class="card-col w250">
                <Ellipsis v-if="lr.name.length" :text="lr.name" :length="27" />
              </div>
              <div class="card-col w250">
                <Ellipsis v-if="lr.lr_number.length" :text="lr.lr_number" :length="25" />

              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="reference">
        <div v-if="getLrDetails.lr_nos.length">
          <Ellipsis
            :text="getLrDetails.lr_nos[0].lr_number"
            :length="5" />
            <span v-if="getLrDetails.count">+ {{getLrDetails.count}}</span>
        </div>
      </div>
    </Popover>
  </div>
  <div class="card-row-col card-col w150">
    {{invoice.invoice_amount}} INR
  </div>
  <div class="card-row-col card-col payment-actions card-action">
    <div class="action error-msg" v-if="invoice.transporter_revision">
      <svgicon name="Exception" width="14" height="14" :original="true"/>
      CR Missing
    </div>
  <div class="action action-secondary" v-if="invoice.invoice_revision.type">
    <Popover placement="bottom-end" trigger="hover">
      <div class="payment-popover popover-primary">
        <div class="popover-primary-header">
          <h3>{{ (invoice.invoice_revision.type === 2) ? 'Debit' : 'Credit'}} Details</h3>
        </div>
        <div class="popover-primary-body table-popover">
          <div class="popover-table">
            <div class="popover-table-header">
              <div class="card-col w250">
                Number: {{invoice.invoice_revision.reference_number}}
              </div>
              <div class="card-col w150">
               Amount: {{ invoice.invoice_revision.amount}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="reference">
      <svgicon v-if="invoice.invoice_revision.type === 2"
            name="debit-note"
            width="14"
            height="14"
            :original="true"/>
      <svgicon v-if="invoice.invoice_revision.type === 1"
          name="credit-note"
          width="14"
          height="14"
          :original="true"/>
      {{(invoice.invoice_revision.amount) ? invoice.invoice_revision.reference_number : '--'}}
      </div>
    </Popover>
    </div>

    <div class="card-edit action" v-if="customFields.length">
        <Popover placement="bottom-end" v-model="customDetailsPop" popper-class="smallpopover">
          <div class="popover-primary">
            <div class="popover-primary-header">
              <h3>Details</h3>
              <span class="remove-icon" @click="customDetailsPop=false">
                <svgicon name="cancel" width="10" height="10" :original="true" />
              </span>
            </div>
            <div class="popover-primary-body">
              <div
                class="col-lg-12 no-padding inputgrid"
                v-for="customField in customFields"
                :key="customField.id"
              >
                <div class="col-lg-12 no-padding">
                  <label>{{customField.label}}</label>
                </div>
                <div class="col-lg-12 no-padding">
                  <input
                    class="w200"
                    v-if="customField.type ==='textbox'"
                    :id="customField.name"
                    v-model="cfields[customField.name]"
                    v-on:keyup="changeCustomfields(customField)"
                  />
                  <DatePicker
                    v-if="customField.type ==='date'"
                    v-model="cfields[customField.name]"
                    type="date"
                    :clearable="false"
                    size="small"
                  />
                </div>
              </div>
              <button class="btn btn-primary floatright" @click="updateCustomFields">Save</button>
            </div>
          </div>
          <div slot="reference">
            <svgicon name="details" width="12" height="12" :original="true" class="iconspace" />Details
          </div>
        </Popover>
      </div>

    <div class="card-edit action" v-if="[9, 10, 11].includes(invoice.status)">
      <Popover placement="bottom-end" trigger="click" v-model="docno">
        <div class="popover-primary">
          <div class="popover-primary-header">
            <h3>Document Number</h3>
            <span class="remove-icon" @click="docno=false">
              <svgicon name="cancel" width="10" height="10" :original="true" />
            </span>
          </div>
          <div class="popover-primary-body" v-if="paymentUpdatedDates">
            <Documentnumber :paymentUpdatedDates="paymentUpdatedDates" />
          </div>
          <div v-else>Loading..</div>
        </div>
        <div slot="reference" @click="$emit('showDates', invoice.id)">
          <svgicon class="topmargin" name="documents" width="14" height="14" :original="true" />
          Doc No
        </div>
      </Popover>
    </div>

    <div class="card-edit action">
      <Popover placement="bottom-end" v-model="comment">
        <div class="popover-primary">
          <div class="popover-primary-header">
            <h3>Comments</h3>
            <span class="remove-icon" @click="comment=false">
              <svgicon name="cancel" width="10" height="10" :original="true" />
            </span>
          </div>
          <div class="popover-primary-body">
            <Comments
              :showForm="commentLoading"
              :comments="comments"
              v-on:addComment="addComment"/>
          </div>
        </div>
        <div @click="loadComments()" slot="reference">
          <svgicon name="Comments" width="14" height="14" :original="true" />
          Comments
        </div>
      </Popover>
    </div>

    <a class="action-accordian">
    <router-link :to="{ name: 'InvoiceDetails', params: { invoiceId: invoice.id }}">
    <svgicon name="arrow-down" class="svg-left" width="12" height="12" :original="true" />
    </router-link>
   </a>
  </div>
</div>
</template>
<script>
import Comments from '@/components/common/comments';
import Documentnumber from '@/components/modules/invoice/common/Documentnumber';

export default {
  name: 'Row',
  components: {
    Comments,
    Documentnumber,
  },
  props: {
    invoice: Object,
    selected: Array,
    voucherVendorId: String,
    voucherForTax: Number,
    commentLoading: Boolean,
    comments: Array,
    customFields: Array,
    paymentUpdatedDates: Array,

  },
  data() {
    return {
      showLrDetails: false,
      showTypeDetails: false,
      comment: false,
      customDetailsPop: false,
      cfields: {},
      docno: false,
      lrDetails: (this.invoice.lr_numbers.length) ? this.invoice.lr_numbers[0] : {},
    };
  },
  created() {
    if (this.invoice.custom_fields) {
      this.cfields = this.invoice.custom_fields;
    }
  },
  computed: {
    isLoading() {
      return this.paymentUpdatedDates.length;
    },
    getLrDetails() {
      const lr_nos = this.invoice.lr_numbers.map(indent =>
        [...new Set(indent.lr_number)].map(lr_number =>
          Object.assign({}, { name: indent.name, lr_number })),
      ).reduce((l, n) => l.concat(n), []);
      return { lr_nos, count: lr_nos.length - 1 };
    },
    checked: {
      get() {
        return this.selected.includes(this.invoice.id);
      },
      set() {
        return false;
      },
    },

    walletTotal() {
      if (this.invoice.wallet_ids && this.invoice.wallet_ids.length) {
        const wallet = this.invoice.wallet_ids.reduce((acc, wal) => acc + wal.amount, 0);
        return wallet;
      }
      return 0;
    },

    disabled() {
      let forcedisable = false;
      if (this.invoice.transporter_revision) {
        forcedisable = true;
      } else if (
        this.voucherVendorId &&
        this.selected.length &&
        this.voucherVendorId !== this.invoice.transporter.id
      ) {
        forcedisable = true;
      } else if (
        this.voucherForTax &&
        this.voucherForTax !== this.invoice.gst_type
      ) {
        forcedisable = true;
      }
      return forcedisable;
    },
  },
  methods: {
    addInvoiceNo(invoice) {
      this.$emit('addInvoice', invoice);
    },
    addComment(comment) {
      this.$emit('addConversation', {
        comment,
        id: this.invoice.id,
        section: 2,
      });
    },
    loadComments() {
      this.$emit('getComments', { id: this.invoice.id, section: 2 });
    },
    changeCustomfields(field) {
      const value = event.currentTarget.value;
      this.cfields[field.name] = value;
    },
    async updateCustomFields() {
      if (this.customFields.length) {
        const hasAnyError = this.customFields.reduce(
          (validateField, customField) => {
            if (customField.required && !this.cfields[customField.name]) {
              validateField.push(`${customField.label} can't be blanks<br/>`);
            }
            return validateField;
          },
          [],
        );
        if (hasAnyError.length) {
          this.$error({ message: hasAnyError.toString() });
        } else {
          this.customFields.forEach((obj) => {
            if (obj.type === 'date') {
              const fieldName = obj.name;
              this.cfields[fieldName] = this.cfields[fieldName].toString();
            }
          });
          const result = await this.$store.dispatch(
            'invoice/customFieldsUpdate',
            {
              id: this.invoice.id,
              fields: this.cfields,
            },
          );
          if (result.custom_fields) {
            this.$success({
              message: `${this.invoice.invoice_number} ${this.$getSuccess(
                'INVOICE_CUSTOMFIELDS_UPDTAE',
              )}`,
            });
            // Refetch invoice After Custom Fields Updates...
            this.$store.commit('invoice/setPage', 1);
            this.$parent.loadMore();
          }
          if (result.error) {
            this.$error({ message: result.error });
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

.popover-primary {
  textarea {
    border: 1px solid #dee5e6;
    width: 100%;
    border-radius: 2px;
    padding: 10px;
    margin: 20px 0;
    outline: none;
  }
  .right-btn {
    float: right;
  }
}
.payment-actions{
  width: calc(100% - 960px);
  text-align: right;
  .action{
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    text-transform: uppercase;
    font-family:$fontSemibold;
    &.error-msg{
      .svg-icon {
        position: relative;
        top:-2px;
      }
    }
    &-accordian{
      cursor: pointer;
    }
    &-secondary{
      color: #404040;
      font-family:$fontSemibold;
      font-size: 1.2rem;
    }
  }
}
.table-popover {
  .card-col {
    padding: 6px 0px;
    color: #404040;
  }
  .popover-table-row{
    .card-col{
      font-family:$fontSemibold;
    }
  }
}
.inputgrid {
  margin: 20px 0;
  label {
    color: #6e6e6e;
    font-size: 1rem;
  }
  input {
    border-bottom: 1px solid #dee5e6;
    border-top: 1px solid transparent;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    height: 30px;
    font-size: 12px;
    outline: none;
  }
}
.floatright {
  float: right;
}
.smallpopover {
  .popover-primary {
    min-width: 230px;
  }
}
.iconspace {
  margin-right: 5px;
}
.topmargin{
  margin-top: -3px;
}
</style>
